export default __webpack_public_path__ + "static/media/favicon.06283969.png";